import { MessageSquare, Phone, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const aiPhoneCallsForPaymentCollectionAr: TemplateAr = {
  name: 'مكالمات ذكية لتحصيل المدفوعات',
  description:
    'مكالمات هاتفية آلية بالذكاء الاصطناعي لتذكير العملاء بالمدفوعات المتأخرة ومتابعة التحصيل بلباقة ومهنية.',
  category: 'المكالمات بالذكاء الاصطناعي',
  workflow: [
    { icon: MessageSquare, label: 'دفعة متأخرة' },
    { icon: Sparkles, label: 'اتصال ذكي' },
    { icon: Phone, label: 'تسوية الدفعة', final: true },
  ],
  detailDescription: {
    paragraph1:
      'ذكّر عميلك بدفعته المتأخرة، بلا مكالمة محرجة على فريقك. الـ AI يتصل بلباقة ومهنية، ويشرح الوضع، ويعرض خيارات السداد، ويقدر يعالج الدفع عبر الهاتف. ويصعّد للموظف البشري عند الحاجة بس.',
    paragraph2:
      'نتائج السداد تلقاها محفوظة في نظام الفوترة أو الـ CRM أو برنامج المحاسبة عندك. والوكيل يتعامل بحساسية، مع الحزم اللي يتطلبه الموقف. ويعدّل أسلوبه حسب تاريخ العميل وأنماط سداده.',
  },
  benefits: [
    'معدلات التحصيل ترتفع بدون توظيف إضافي',
    'تحافظ على علاقتك بالعميل وأنت تحصّل',
    'متوسط فترة التحصيل (DSO) ينزل',
    'يعالج المدفوعات ٢٤/٧',
    'يصعّد للبشر عند الحاجة بس',
    'التزام كامل بأنظمة التحصيل',
  ],
};
